import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, Printer, FileDown, FilePlus2, UserRound } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { Loader } from "../components/kit";
import ScaledMemo from "../components/ScaledMemo";
import PrintSizeControl from "../components/PrintSizeControl";
import { loadPrintSize, savePrintSize, applyPrintStyle, PrintSize } from "../lib/printSize";

export default function MemoView() {
  const { id } = useParams();
  const [memo, setMemo] = useState<any>(null);
  const [full, setFull] = useState(false);
  const [busy, setBusy] = useState(false);
  const [printSize, setPrintSize] = useState<PrintSize>(() => loadPrintSize());

  useEffect(() => { applyPrintStyle(printSize); }, [printSize]);
  const changeSize = (s: PrintSize) => { setPrintSize(s); savePrintSize(s); };

  useEffect(() => {
    api.get(`/memos/${id}`).then((r) => setMemo(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [id]);

  const pdf = async () => {
    setBusy(true);
    setFull(true);
    await new Promise((r) => setTimeout(r, 150));
    try {
      const html2pdf = (await import("html2pdf.js")).default;
      const el = document.querySelector("[data-testid='print-memo-a4-container']");
      await html2pdf().set({
        margin: 0, filename: `${memo.invoice_no}.pdf`, image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "in", format: [printSize.wIn, printSize.hIn], orientation: printSize.wIn > printSize.hIn ? "landscape" : "portrait" },
        pagebreak: { mode: ["avoid-all"] },
      }).from(el).save();
      toast.success("PDF ডাউনলোড হয়েছে");
    } catch {
      toast.error("PDF তৈরি করা যায়নি");
    } finally {
      setFull(false);
      setBusy(false);
    }
  };

  if (!memo) return <Loader />;
  return (
    <div data-testid="memo-view-page">
      <div className="no-print flex flex-wrap items-center justify-between gap-2 mb-4">
        <Link to="/memos" className="btn btn-ghost btn-sm" data-testid="memo-back-button"><ArrowLeft size={16} /> মেমো তালিকা</Link>
        <div className="flex flex-wrap gap-2">
          {memo.customer?.id && <Link to={`/customers/${memo.customer.id}`} className="btn btn-ghost btn-sm" data-testid="memo-customer-link"><UserRound size={16} /> ক্রেতার হিসাব</Link>}
          <Link to="/memo/new" className="btn btn-ghost btn-sm" data-testid="memo-new-button"><FilePlus2 size={16} /> নতুন মেমো</Link>
          <button className="btn btn-ghost btn-sm" onClick={pdf} disabled={busy} data-testid="memo-pdf-download-button"><FileDown size={16} /> {busy ? "তৈরি হচ্ছে..." : "PDF"}</button>
          <button className="btn btn-primary btn-sm" onClick={() => window.print()} data-testid="memo-print-button"><Printer size={16} /> প্রিন্ট</button>
        </div>
      </div>
      <div className="no-print mb-4">
        <PrintSizeControl value={printSize} onChange={changeSize} />
      </div>
      <div className="bg-slate-200/60 rounded-xl p-2 sm:p-6 overflow-hidden">
        <ScaledMemo memo={memo} full={full} />
      </div>
    </div>
  );
}
